export default __webpack_public_path__ + "static/media/Q0005.283b89a2.png";